<template>
  <a-col :span="24">
    <a-row>
      <a-row v-if="new_comment" style="background:   #f5f6f5;">
        <a-col :xs="22" :sm="22" :md="14" :lg="14" :xl="14" style="margin: 5px 0px;">
          <a-col :xs="4" :sm="4" :md="3" :lg="2" :xl="2" >
            <a-avatar :size="40" v-if="user_head" :src="user_head" alt="avatar"  :style="profileMargin"/>
            <a-avatar v-else :size="40" style="background: #1890ff; color: #fff;" icon="user" :style="profileMargin" />
          </a-col> 
          <a-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3" style="margin: 10px 0px;text-align:center"> 
            <span style="margin-right: 4px; margin-left: 0px;">{{user_name}}</span>
          </a-col>
          <a-col :xs="16" :sm="16" :md="12" :lg="12" :xl="12" style=" margin-top: 10px; text-align:right">
             <a-select v-if="tag == 1" :defaultValue="contact_type" @change="handleContactSrc" size="small" style="width: 70px; font-size: 12px; margin-right: 4px;margin-left: 4px;">
               <a-select-option v-for="contact_type in contactType" :key="contact_type" style="">{{contact_type}}</a-select-option>
             </a-select>                 
             <a-select v-if="tag == 1" :defaultValue="user_status" @change="handleUserType" size="small" style="width: 90px; font-size: 12px; margin-left: 4px; margin-right: 5px;">
               <a-select-option v-for="user_status in userStatus" :key="user_status" style="">{{user_status}}</a-select-option>
             </a-select>
           </a-col>
         </a-col>
         <a-col  :xs="2" :sm="2" :md="10" :lg="10" :xl="10"  style=" margin-top: 18px; text-align:right"> 
           <a-icon type="save" @click= "addThisItem" style=" font-size: 16px; margin-right: 10px; "/>  
         </a-col>
         <a-col :span="24" style=" padding: 0px 10px;">
           <a-textarea  v-model="comment" rows="4" placeholder="添加工作笔记..." style=""></a-textarea>
         </a-col>
       </a-row>
       <a-row v-else style=" background: #f5f6f5; " >
         <a-col :xs="16" :sm="16" :md="14" :lg="14" :xl="14" style="padding: 5px 0px;">
           <a-col :xs="6" :sm="6" :md="3" :lg="2" :xl="2" >
             <a-avatar :size="40" v-if="user_head" :src="user_head" alt="avatar"  :style="profileMargin"/>
             <a-avatar v-else :size="40" style="background: #1890ff; color: #fff;" icon="user" :style="profileMargin"/>
           </a-col> 
           <a-col :xs="6" :sm="6" :md="4" :lg="3" :xl="3">
             <a-col :span='24'>
               <span style=" margin-right: 4px;margin-left: 4px; text-align:center ">{{user_name}}</span>
             </a-col>
             <a-col :span='24'>
               <span style=" margin-right: 4px;margin-left: 4px; font-size: 10px; text-align:center">
                 <time-ago class="time-font" :refresh="60" :datetime='time' locale="zh_CN" :long="true">
                 </time-ago> 
               </span>
             </a-col>
           </a-col>
           <a-col :xs="12" :sm="12" :md="6" :lg="4" :xl="4">
             <span  v-if="tag == 1" style="margin-right: 4px; margin-left: 4px;">{{contact_type}}</span>
             <span  v-if="tag == 1" style="margin-right: 4px; margin-left: 4px;">{{user_status}}</span>
           </a-col>
         </a-col>
         <a-col  :xs="8" :sm="8" :md="10" :lg="10" :xl="10"  style=" margin: 5px 0px; text-align:right"> 
           <a v-if="top == 0" @click="topThisItem(order)">
              <a-icon type="to-top" style="font-size: 16px;"/>            
           </a>
           <a v-if="top == 1" @click="resetThisItem(order)">
              <a-icon :component="ArrowBottomIcon" :style="styleABI"/>
           </a>
           <a @click="deleteThisItem(order)" >
             <a-icon type="delete" style=" font-size: 16px; margin-right: 10px; margin-left: 8px;"/>
           </a>
         </a-col>
         <a-col :span="24" style="padding: 0px 20px;">
           <span  style="word-break: break-all;">{{comment}}</span>
         </a-col>
       </a-row>
       <a-row style=" background:  #f5f6f5; padding: 5px 0px;">
       </a-row>
    </a-row>
  </a-col>
</template>
<script>
import TimeAgo from "vue2-timeago"; 

import ArrowBottomIcon from '@/assets/img/arrow-to-bottom.vue'; 

const contactType = ['到访','电话','微信','短信','邮箱','QQ','发现','其他'];
const userStatus = ['了解产品','正在跟进','正在试用','准备购买','准备付款','已经购买','暂时搁置','潜在客户'];

export default {
  name: "Record",

  components: {
    TimeAgo,
  },
  props: {
    time: Number,
    default: function() {
      return {}
    },
    top: Number,
    default: function() {
      return {}
    },
    order: Number,
    default: function() {
      return {}
    },
    Ent_tag: {
      type: Number,
      default: function() {
        return 0
      }
    },
    item: {
      type: Object,
      default: function() {
        return {
          contact_type: "到访",
          user_status: "了解产品",
          comment: "",
        }
      }
    }
  },

  data() {
    return {
      ArrowBottomIcon, 
      styleABI: "width: 16px; height: 16px", 
      contactType,
      userStatus,
      contact_type: this.item.contact_type,
      user_status: this.item.user_status,
      comment: this.item.comment,
      user:{},
      user_head: "",
      user_name: "",
      tag: this.Ent_tag,
      new_comment: true,
      profileMargin: {
        'border': '1px solid #E2E2E2',
        'margin-left': '10px',
        'margin-right': '4px'
        }
    }
  },
  filters: {
    TimeChangeUtc(value) {
      value = parseInt(value);
      let current = Math.floor(Date.now());
      let previous = value;
      var msPerMinute = 60 * 1000;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;
      var elapsed = current - previous;
      if (elapsed < msPerMinute) {
        return Math.round(elapsed/1000) + '秒';   
      } else if (elapsed < msPerHour) {
        let m =Math.round(elapsed/msPerMinute); 
        var min = m + "分钟";
        return min;
      } else if (elapsed < msPerDay ) {
        let h =Math.round(elapsed/msPerHour );  
        var hr = h + "小时";
        return hr;
      } else if (elapsed < msPerMonth) {
        let d=Math.round(elapsed/msPerDay);
        var day = d + "天";
        return day;   
      } else if (elapsed < msPerYear) {
        let M=Math.round(elapsed/msPerMonth); 
        var month = M + "月";
        return month;  
      } else {
        let y =Math.round(elapsed/msPerYear );
        var year = y + "年";
        return year;   
      }
    }
  },
  methods: {
    topThisItem: function(order) {
        this.$emit('topitem', order);
    },
    resetThisItem: function(order) {
        this.$emit('resetitem', order);
    },
    deleteThisItem: function(order) {
      this.$emit('deleteitem', order);
    },
    addThisItem: function() {
      let commentData={ 
        comment: this.comment,
        contact_type: this.contact_type,
        user_status: this.user_status,
      }
      if (this.comment != "") {
        this.$emit('additem', commentData);
      } else {
        this.$message.info("请填写内容");
      }   
    },
    handleContactSrc(value) {
      this.contact_type = value
    },
    handleUserType(value) {
      this.user_status = value
    }
  },
  created() {
    if (this.comment != "") {
      this.new_comment= false
    } else {
      this.new_comment= true

    }
    this.user_head = this.$store.getters.getUIcon();
    this.user_name = this.$store.getters.getUsername();

    let deviceWidth = document.body.clientWidth
    if (deviceWidth <= 375) {
      this.profileMargin['margin-left'] = '5px'
    }
  }
}
</script>
<style>
.time-font span {
  font-weight: 100;
  font-size: 10px;
}

</style>

